import React = require('react');
import { UserSettings } from '../services/resources/UserSettings';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { Messages } from '../../codegen/Localize';
import { Formik, FormikProps } from 'formik';
import _ = require('underscore');
import { FormikCheckbox } from '../../commonInfra/components/FormikCheckbox';
import { InlineCancelAndSaveButtons } from './UserSettingEditButtons';
import { NotificationsSettingsProps } from './NotificationsSettings';

export interface SubscriptionNotificationField {
    subscriptionNotificationEnabled: boolean;
}

function showButtons(formik: FormikProps<SubscriptionNotificationField>, subscriptionNotificationEnabled: boolean) {
    if (!formik.touched || !formik.isValid || formik.isSubmitting || _.isEqual(formik.values.subscriptionNotificationEnabled, subscriptionNotificationEnabled)) {
        return false;
    }
    return true;
}

export function SubscriptionNotification(props: NotificationsSettingsProps): JSX.Element {
    const [currentSubscriptionNotificationEnabled, setCurrentSubscriptionNotificationEnabled] = React.useState(false);

    async function handleSubmit(values: SubscriptionNotificationField) {
        UserSettings.updateSuspendedSubscriptionSetting(props.siteUser.id, values.subscriptionNotificationEnabled).then(() => {
            setCurrentSubscriptionNotificationEnabled(values.subscriptionNotificationEnabled);
            ToasterService.instance.pop({ type: ToastType.Success, text: Messages.settingsUpdateSuccess() });
        }).catch(() => {
            ToasterService.instance.pop({ type: ToastType.Error, text: Messages.settingsUpdateFailure() });
        });
    }

    React.useEffect(() => {
        UserSettings.getSuspendedSubscriptionSetting(props.serverUser.id)
            .then((result: boolean) => {
                setCurrentSubscriptionNotificationEnabled(result);
            }).catch(() => { });
    }, []);

    return (
        <Formik
            initialValues={{ subscriptionNotificationEnabled: currentSubscriptionNotificationEnabled }}
            onSubmit={(values: SubscriptionNotificationField) => handleSubmit(values)}
            enableReinitialize={true}
        >
            {
                (formik: FormikProps<SubscriptionNotificationField>) => (
                    <form onSubmit={formik.handleSubmit}>
                        <table>
                            <tbody className={UserSettingsStyle.tbodyNew}>
                                <tr data-tb-test-id="userSettings-subscription-notification">
                                    <td className={UserSettingsStyle.labelTextNew}>
                                        {Messages.subscriptions()}
                                    </td>
                                    <td className={UserSettingsStyle.detailsValue}>
                                        {Messages.subscriptionSuspendedNotificationUserSettingDetail()}
                                    </td>
                                </tr>
                                <tr>
                                    <td className={UserSettingsStyle.labelTextNew} />
                                    <td className={UserSettingsStyle.detailsValue}>
                                        <FormikCheckbox
                                            containerStyle={{ marginLeft: 0 }}
                                            testId='Subscription-Notification-Enabled'
                                            name={'subscriptionNotificationEnabled'}
                                            disabled={props.userHasNoSiteId}
                                            label={Messages.subscriptionSuspendedNotificationUserSettingEnable()} />
                                    </td>
                                </tr>
                                {
                                    showButtons(formik, currentSubscriptionNotificationEnabled) &&
                                    <InlineCancelAndSaveButtons
                                        testId={'subscription-notification'}
                                        formik={formik}
                                    />
                                }
                            </tbody>
                        </table>
                    </form>
                )
            }
        </Formik>
    );
}